import React from "react";
import ICatalog_Item from "../../../models/ICatalog_Item";
import OwLabel from "../OwLabel/OwLabel";

type Props = {
    catalogItem: ICatalog_Item;
    qty?: number;
};

export const PackQtyViewer: React.FC<Props> = (props) => {
    return (
        <div className={"PackQtyViewer"}>
            {props.catalogItem.has_pack_qty ? (
                <div className={"text-small text-center mt-2"}>
                    {props.catalogItem.pack_qty ? (
                        <div>
                            <div>
                                <OwLabel title={"pack_qty"} isBold={true} className={"me-2"} postText={":"} />
                                {props.catalogItem.pack_qty}
                            </div>
                            <div>
                                <OwLabel title={"total_packs"} isBold={true} className={"me-2"} postText={":"} />
                                {props.qty || 0}
                            </div>
                            <div>
                                <OwLabel title={"total_units"} isBold={true} className={"me-2"} postText={":"} />
                                {(props.catalogItem.pack_qty || 1) * (props.qty || 0)}
                            </div>
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};
